import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./features/overview/overview.component').then((m) => m.OverviewComponent),
  },
  {
    path: 'assignment/klankbord',
    loadComponent: () => import('./features/assignments/klankbord/klankbord.component').then((m) => m.KlankbordComponent),
  },
];
